import { render, staticRenderFns } from "./ServiceDashboardSessionLoad.vue?vue&type=template&id=b3bd9fce&"
import script from "./ServiceDashboardSessionLoad.vue?vue&type=script&setup=true&lang=js&"
export * from "./ServiceDashboardSessionLoad.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports